export const YEAR = 'year';
export const MONTH = 'month';
export const DAY = 'day';
export const HOUR = 'hour';
export const MINUTE = 'minute';
export const WEEK = 'week';
